module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/julita-nowik-grodek-d45a403abcd03c4c2b6d85c7412d909e.png";